// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__q4IVy","buttonContainer":"styles_buttonContainer__a4MLO"};